import React, { useState, useEffect, useRef } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import axios from "axios";
import { Search } from "lucide-react";
import Modal from "../components/common/CommonModal";
import CreditCustomerList from "../components/common/CreditCustomerList";

const Group2Selector = ({
  accounts,
  value,
  setValue,
  onSelectedAccountParent,
}) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const inputRef = useRef();
  const [inputValue2, setInputValue2] = useState("");
  const [filteredAccounts, setFilteredAccounts] = useState([]);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen2, setModalOpen2] = useState(false);
  const [selectedGroup2, setSelectedGroup2] = useState(null);
  const [accountListFromAPI, setAccountListFromAPI] = useState([]);
  const [searchGroup2Term, setSearchGroup2Term] = useState("");
  const [highlightedIndex, setHighlightedIndex] = useState(0);

  useEffect(() => {
    fetchAccountList();
  }, []);

  const fetchAccountList = async () => {
    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CpaysCount/${COMPANY_CODE}/ACCOUNTGROUP/-/-`;
    try {
      const response = await axios.get(apiUrl);
      setAccountListFromAPI(response.data);
    } catch (err) {
      console.error("Error while fetching group2 accounts", err);
    }
  };

  // Live filter for dropdown
  useEffect(() => {
    if (!inputValue2.trim()) {
      setFilteredAccounts(accountListFromAPI);
    } else {
      const term = inputValue2.toLowerCase();
      setFilteredAccounts(
        (accountListFromAPI ?? []).filter(
          (acc) =>
            acc.DESCRIPTION?.toLowerCase().includes(term) ||
            acc.GRP_CODE?.toLowerCase().includes(term),
        ),
      );
    }
  }, [inputValue2, accountListFromAPI]);

  // Modal filtering (separate search bar inside modal)
  const filteredSearchedAccounts = !searchGroup2Term.trim()
    ? accountListFromAPI
    : accountListFromAPI.filter(
        (acc) =>
          acc.GRP_CODE?.toLowerCase().includes(
            searchGroup2Term.toLowerCase(),
          ) ||
          acc.DESCRIPTION?.toLowerCase().includes(
            searchGroup2Term.toLowerCase(),
          ),
      );

  // Open modal on F2 press
  // useEffect(() => {
  //   const handleKeyDown2 = (e) => {
  //     if (e.key === "F2" && document.activeElement === inputRef.current) {
  //       e.preventDefault();
  //       setModalOpen2(true);
  //     }
  //   };
  //   window.addEventListener("keydown", handleKeyDown2);
  //   return () => window.removeEventListener("keydown", handleKeyDown2);
  // }, []);

  // Keyboard navigation in modal
  useEffect(() => {
    if (!isModalOpen2) return;

    const handleKeyDown = (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        setHighlightedIndex((prev) =>
          Math.min(prev + 1, filteredSearchedAccounts.length - 1),
        );
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        setHighlightedIndex((prev) => Math.max(prev - 1, 0));
      } else if (e.key === "Enter") {
        e.preventDefault();
        const selected = filteredSearchedAccounts[highlightedIndex];
        if (selected) {
          setInputValue2(`${selected.GRP_CODE} - ${selected.DESCRIPTION}`);
          setSelectedGroup2(selected);
          onSelectedAccountParent(selected.GRP_CODE);
          setModalOpen2(false);
        }
      } else if (e.key === "Escape") {
        e.preventDefault();
        setModalOpen2(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen2, highlightedIndex, filteredSearchedAccounts]);

  const clearAccounts = () => {
    setInputValue2("");
    setSelectedGroup2(null);
    onSelectedAccountParent("-");
  };

  const [isModalOpenGroup2, setIsModalOpenGroup2] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "F2" && document.activeElement === inputRef.current) {
        e.preventDefault();
        // setModalOpen1(true);
        setIsModalOpenGroup2(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleCustomerSelect = (data) => {
    console.log("data:", data);
    setSelectedAccount(data);
    onSelectedAccountParent(data.ACCOUNT);
    // setModalOpen1(false);
    setIsModalOpenGroup2(false);

    setInputValue2(`${data.ACCOUNT} - ${data.DESCRIPTION}`);
    setSelectedGroup2(data);
    onSelectedAccountParent(data.ACCOUNT);
    // onSelectedAccountParent(data.GRP_CODE);
  };

  console.log("SelectedGroup2:", selectedGroup2);

  return (
    <div className="relative w-[380px]">
      {/* Input Field */}
      <div className="flex justify-between bg-white items-center w-full border border-gray-300 rounded px-3 py-1">
        <input
          type="text"
          ref={inputRef}
          // value={inputValue2}
          value={inputValue2 === "-" ? "" : inputValue2}
          placeholder="Select or type Group 2"
          onChange={(e) => {
            setInputValue2(e.target.value);
            setDropdownOpen(true);
          }}
          onFocus={() => setDropdownOpen(true)}
          onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
          className="w-full bg-transparent border-none outline-none focus:outline-none focus:ring-0"
        />
        {/* {inputValue2 && ( */}
        {inputValue2 !== "" && inputValue2 !== "-" && (
          <button className="rounded text-gray-800" onClick={clearAccounts}>
            <ClearIcon fontSize="small" />
          </button>
        )}
      </div>

      {/* Dropdown */}
      {isDropdownOpen && filteredAccounts.length > 0 && (
        <ul
          className="absolute bg-white border border-gray-300 w-full mt-1 max-h-44 shadow-lg overflow-y-auto z-10 rounded-md"
          onMouseDown={(e) => e.preventDefault()} // prevent blur
        >
          {filteredAccounts.map((acc, i) => (
            <li
              key={i}
              onClick={() => {
                setInputValue2(`${acc.GRP_CODE} - ${acc.DESCRIPTION}`);
                setSelectedGroup2(acc);
                setDropdownOpen(false);
                onSelectedAccountParent(acc.GRP_CODE);
              }}
              className="px-3 py-2 text-sm text-gray-700 hover:bg-blue-100 cursor-pointer transition-colors"
            >
              <div className="flex flex-col border-b pb-1">
                <span className="font-medium">{acc.GRP_CODE}</span>
                <span className="text-xs text-gray-500 truncate">
                  {acc.DESCRIPTION}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}

      {/* Modal */}
      {/* // <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-50"> */}
      {/* <div className="bg-white rounded-2xl shadow-2xl flex flex-col w-full max-w-2xl mx-4 sm:mx-6 h-[70vh] overflow-hidden"> */}
      {/* // Header */}
      {isModalOpen2 && (
        <Modal
          isOpen={isModalOpen2}
          onClose={() => setModalOpen2(false)}
          title={"Select Group 2"}
          // size="xxl"
          header={true}
        >
          <div className="flex justify-between items-center py-3 px-5 border-b border-gray-200 bg-gray-50 sticky top-0 z-20">
            {/* <h2 className="text-lg font-semibold text-gray-800">Select Group 2</h2> */}
            <div className="relative flex-1 mx-4">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
              <input
                className="w-full pl-10 pr-10 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm placeholder-gray-400"
                type="text"
                placeholder="Search Group 2"
                value={searchGroup2Term}
                onChange={(e) => setSearchGroup2Term(e.target.value)}
              />
              {searchGroup2Term && (
                <button
                  type="button"
                  onClick={() => setSearchGroup2Term("")}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                >
                  <ClearIcon fontSize="small" />
                </button>
              )}
            </div>
            {/* <button
                className="p-2 rounded-full hover:bg-gray-200 transition-colors"
                onClick={() => setModalOpen2(false)}
              >
                <ClearIcon fontSize="small" className="text-gray-600" />
              </button> */}
          </div>

          {/* Table */}
          <div className="flex-1 overflow-y-auto">
            <table className="min-w-full table-auto border-collapse">
              <thead className="bg-gray-100 sticky top-0 z-10">
                <tr>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b border-gray-200">
                    Group Code
                  </th>
                  <th className="px-4 py-3 text-sm text-left font-medium text-gray-700 border-b border-gray-200">
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredSearchedAccounts?.map((acc, i) => (
                  <tr
                    key={i}
                    onClick={() => {
                      setInputValue2(`${acc.GRP_CODE} - ${acc.DESCRIPTION}`);
                      setSelectedGroup2(acc);
                      onSelectedAccountParent(acc.GRP_CODE);
                      setModalOpen2(false);
                    }}
                    className={`cursor-pointer transition-colors duration-150 ${
                      highlightedIndex === i
                        ? "bg-blue-100"
                        : "hover:bg-blue-50"
                    }`}
                  >
                    <td className="text-sm px-4 py-2 border-b border-gray-200 text-gray-700">
                      {acc.GRP_CODE}
                    </td>
                    <td className="text-sm px-4 py-2 border-b border-gray-200 text-gray-600">
                      {acc.DESCRIPTION}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal>

        //   {/* </div> */}
        // {/* // </div> */}
      )}

      {isModalOpenGroup2 && (
        <Modal
          isOpen={isModalOpenGroup2}
          onClose={() => setIsModalOpenGroup2(false)}
          title={"Statement Account"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="All"
            handleCustomerSelect={handleCustomerSelect}
          />
          {/* <ProductListing/> */}
        </Modal>
      )}
    </div>
  );
};

export default Group2Selector;
